import { SectionCard, SectionCardTitle } from "@/components";
import { useEffect, useRef } from "react";

// Countries to highlight with brand color
const HIGHLIGHTED_COUNTRIES = ["IN", "BD", "LK", "ID", "PH", "TH", "VN"];

// Label positions in the worldHigh.svg coordinate space (viewBox: -2 17.68 964 924.64)
const COUNTRY_LABELS: { id: string; label: string; x: number; y: number; fontSize?: number }[] = [
  { id: "IN", label: "India", x: 691, y: 400, fontSize: 10 },
  { id: "BD", label: "Bangladesh", x: 724, y: 395, fontSize: 5 },
  { id: "LK", label: "Sri Lanka", x: 703, y: 450, fontSize: 7 },
  { id: "ID", label: "Indonesia", x: 790, y: 462, fontSize: 7 },
  { id: "PH", label: "Philippines", x: 828, y: 430, fontSize: 5 },
  { id: "TH", label: "Thailand", x: 750, y: 417, fontSize: 6 },
  { id: "VN", label: "Vietnam", x: 779, y: 415, fontSize: 6 },
];

// Google Maps link for India office
const INDIA_MAPS_URL =
  "https://www.google.com/maps/dir//Intron+Life+Sciences+Pvt+Ltd,+2nd+Floor+,+Vamsiram+Jyothi+Celesta+Plot+%23+66,+Kavuri+Hills,+Jubilee+Hills,+Hyderabad,+Telangana+500033/data=!4m6!4m5!1m1!4e2!1m2!1m1!1s0x3bcb911eb8727c2f:0x2d25cfc2cbc06d1b?sa=X&ved=1t:57443&ictx=111";

const Map = () => {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    fetch("/worldIndiaHigh.svg")
      .then((res) => res.text())
      .then((svgText) => {
        if (!container) return;

        // Parse the SVG
        const parser = new DOMParser();
        const doc = parser.parseFromString(svgText, "image/svg+xml");
        const svgEl = doc.querySelector("svg");
        if (!svgEl) return;

        // Make SVG responsive
        svgEl.removeAttribute("width");
        svgEl.removeAttribute("height");
        svgEl.setAttribute("width", "100%");
        svgEl.setAttribute("height", "100%");
        svgEl.style.display = "block";

        // Set default fill & border for ALL country paths
        svgEl.querySelectorAll("path[id]").forEach((path) => {
          path.setAttribute("fill", "#FCFEFF");
          path.setAttribute("stroke", "#D8D8D8");
          path.setAttribute("stroke-width", "0.5");
        });

        // Override highlighted countries with brand color
        HIGHLIGHTED_COUNTRIES.forEach((countryId) => {
          const path = svgEl.querySelector(`#${CSS.escape(countryId)}`);
          if (path) {
            path.setAttribute("fill", "#E85222");
            path.setAttribute("stroke", "#D8D8D8");
          }
        });

        // Wrap India path in a clickable anchor
        const indiaPath = svgEl.querySelector("#IN");
        if (indiaPath) {
          const anchor = document.createElementNS("http://www.w3.org/2000/svg", "a");
          anchor.setAttributeNS("http://www.w3.org/1999/xlink", "href", INDIA_MAPS_URL);
          anchor.setAttribute("target", "_blank");
          anchor.setAttribute("rel", "noopener noreferrer");
          anchor.style.cursor = "pointer";
          indiaPath.parentNode?.insertBefore(anchor, indiaPath);
          anchor.appendChild(indiaPath);
        }

        // Add a label group on top
        const labelGroup = document.createElementNS("http://www.w3.org/2000/svg", "g");
        labelGroup.setAttribute("id", "country-labels");

        COUNTRY_LABELS.forEach(({ id, label, x, y, fontSize = 10 }) => {
          const text = document.createElementNS("http://www.w3.org/2000/svg", "text");
          text.setAttribute("id", `${id}-label`);
          text.setAttribute("x", String(x));
          text.setAttribute("y", String(y));
          text.setAttribute("text-anchor", "middle");
          text.setAttribute("dominant-baseline", "middle");
          text.setAttribute("pointer-events", "none");
          text.setAttribute("fill", "#FFFFFF");
          text.setAttribute("stroke", "#000000");
          text.setAttribute("stroke-width", "0.4");
          text.setAttribute("paint-order", "stroke");
          text.setAttribute("font-size", String(fontSize));
          text.setAttribute("font-family", "inherit");
          text.setAttribute("font-weight", "600");
          text.textContent = label;
          labelGroup.appendChild(text);
        });

        svgEl.appendChild(labelGroup);

        // Clear previous and insert the modified SVG
        container.innerHTML = "";
        container.appendChild(svgEl);
      })
      .catch((err) => {
        console.error("Failed to load world map SVG:", err);
      });
  }, []);

  return (
    <section className="bg-blue-900 lg:pb-[100px] relative">
      <SectionCard className="bg-[url('/img/testimonials_bg.png')] bg-no-repeat bg-left bg-contain flex flex-col items-center justify-center text-white">
        <SectionCardTitle className="lg:w-full mb-6 text-center">
          Our Presence
        </SectionCardTitle>
        <div className="relative w-full flex items-center justify-center lg:mt-10">
          <div
            ref={containerRef}
            className="w-full"
            style={{ aspectRatio: "964 / 924.64" }}
          />
        </div>
      </SectionCard>
    </section>
  );
};

export default Map;
